export const WORKSPACE_CORNER_MARGIN_PX = 20;
/** Blockly trashcan bounding size from blockly/core trashcan */
export const WORKSPACE_TRASH_SIZE_PX = { width: 47, height: 60 };

export function getTrashTranslate(container: HTMLElement): { x: number; y: number } | null {
  const height = container.clientHeight;
  const width = container.clientWidth;
  if (height === 0 || width === 0) {
    return null;
  }
  return {
    x: width - WORKSPACE_TRASH_SIZE_PX.width - WORKSPACE_CORNER_MARGIN_PX,
    y: height - WORKSPACE_TRASH_SIZE_PX.height - WORKSPACE_CORNER_MARGIN_PX,
  };
}

/** Keep Blockly trash pinned to workspace bottom-right. */
export function syncTrashPosition(container: HTMLElement): void {
  const trash = container.querySelector('.blocklyTrash');
  if (!(trash instanceof SVGGElement)) {
    return;
  }

  const position = getTrashTranslate(container);
  if (!position) {
    return;
  }

  const transform = `translate(${position.x}, ${position.y})`;
  if (trash.getAttribute('transform') !== transform) {
    trash.setAttribute('transform', transform);
  }
}

export function attachTrashPositionSync(container: HTMLElement): () => void {
  const runSync = () => syncTrashPosition(container);
  let trashObserver: MutationObserver | null = null;

  const observeTrash = () => {
    if (trashObserver) {
      return;
    }
    const trash = container.querySelector('.blocklyTrash');
    if (!(trash instanceof SVGGElement)) {
      return;
    }
    trashObserver = new MutationObserver(() => {
      requestAnimationFrame(runSync);
    });
    trashObserver.observe(trash, { attributes: true, attributeFilter: ['transform'] });
  };

  const resizeObserver = new ResizeObserver(() => {
    requestAnimationFrame(() => {
      observeTrash();
      runSync();
    });
  });
  resizeObserver.observe(container);

  const containerObserver = new MutationObserver(() => {
    observeTrash();
    runSync();
  });
  containerObserver.observe(container, { childList: true, subtree: true });

  requestAnimationFrame(() => {
    observeTrash();
    runSync();
  });
  const retryTimers = [0, 50, 200, 500].map((delay) =>
    window.setTimeout(() => {
      observeTrash();
      runSync();
    }, delay),
  );

  return () => {
    resizeObserver.disconnect();
    containerObserver.disconnect();
    trashObserver?.disconnect();
    retryTimers.forEach((id) => window.clearTimeout(id));
  };
}
